<!-- 
<div class="div-loader" *ngIf=LoaderStatus>
  <img class="div-loader-image" src="src\assets\img\loader.gif" />
</div> -->
<div class="container-fluid content">
  <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="row" style="padding-left:35%;margin-top:20%;">
              <div class="col-lg-1 col-md-2 col-sm-3">
                  <img src="assets\img\EY-logo-li.png" style="width:50px;height:50px;"/>
              </div>
              <div class="col-lg-11 col-md-10 col-sm-9 login-main-body" >
                  <span style="float: left;padding-top: 23px;">IN Contract Renewal System</span>
              </div>
          </div>
      </div>
  </div>
</div>
